import QrPayments from "./QrPayments";

export default QrPayments;
